import React from 'react';
import Swal from 'sweetalert2';
import { currencyFormat } from '../../js/Functions';
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faArrowRight, faCalendarAlt, faCalendarCheck, faDollarSign, faEdit, faFilter, faHashtag, faPlus, faSave, faSync, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

class Consultar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        loadMensual: true,
        loadRango: true,
        mes_consulta_mes: '',
        periodo_consulta_mes: '',
        fecha_inicial: '',
        fecha_final: '',
        periodosConsultaMes: [],
        consultaGeneradaMes: [],
        consultaGeneradaRango: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    seleccionarPeriodo = (periodo, tipo_consulta) => {
        switch (tipo_consulta) {
            case 'mensual':
                var mes_consulta_mes = document.getElementById('mes_consulta_mes_' + periodo).value;
                this.setState({
                    datosCargados: true,
                    mes_consulta_mes: mes_consulta_mes,
                    periodo_consulta_mes: periodo + mes_consulta_mes
                });
                break;
            default: break;
        }

    }
    consultarInfo = (tipo_consulta) => {
        switch (tipo_consulta) {
            case 'mensual':
                this.setState({
                    consultaGeneradaMes: [],
                    loadMensual: true
                });
                const { periodo_consulta_mes } = this.state;
                var errores = [];
                if (!periodo_consulta_mes) { errores.push("error_periodo_consulta_mes"); }
                console.log(errores.length);
                this.setState({ errores: errores });
                if (errores.length > 0) {
                    return false;
                }
                let formMes = document.getElementById('form-mensual');
                let formDataMes = new FormData(formMes);
                formDataMes.append('tipo_consulta', tipo_consulta);
                Swal.showLoading();
                authAxios.post("consultas/pqr", formDataMes)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        Swal.close();
                        var status = datosRespuesta.data.status;
                        if (status) {
                            Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                            window.localStorage.clear();
                            window.location.href = '/';
                        }
                        if (datosRespuesta.data.length > 0) {
                            this.setState({
                                datosCargados: true,
                                loadMensual: false,
                                consultaGeneradaMes: datosRespuesta.data
                            });
                        }
                    })
                    .catch(console.log);
                break;
            case 'rango':
                this.setState({
                    consultaGeneradaRango: [],
                    loadRango: true
                });
                const { fecha_inicial, fecha_final } = this.state;
                var errores = [];
                if (!fecha_inicial) { errores.push("error_fecha_inicial"); }
                if (!fecha_final) { errores.push("error_fecha_final"); }

                this.setState({ errores: errores });
                if (errores.length > 0) {
                    return false;
                }
                if (fecha_final >= fecha_inicial) {
                    let formRango = document.getElementById('form-rango');
                    let formDataRango = new FormData(formRango);
                    formDataRango.append('tipo_consulta', tipo_consulta);
                    Swal.showLoading();
                    authAxios.post("consultas/pqr", formDataRango)
                        .then((datosRespuesta) => {
                            console.log(datosRespuesta);
                            Swal.close();
                            var status = datosRespuesta.data.status;
                            if (status) {
                                Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                                window.localStorage.clear();
                                window.location.href = '/';
                            }
                            if (datosRespuesta.data.length > 0) {
                                this.setState({
                                    datosCargados: true,
                                    loadRango: false,
                                    consultaGeneradaRango: datosRespuesta.data
                                });
                            }

                        })
                        .catch(console.log);
                } else {
                    this.setState({ loadRango: true, })
                    Swal.fire('Error de fechas ', 'La fecha final debe ser mayor', 'info');
                }
                break;
            default: break;
        }
    }
    cancelarConsulta = (tipo_consulta) => {
        switch (tipo_consulta) {
            case 'mensual':
                this.setState({
                    periodosConsultaMes: [],
                    periodo_consulta_mes: '',
                    consultaGeneradaMes: [],
                    loadMensual: true
                });
                Swal.showLoading();
                authAxios.get("estado_cuentas/periodos_estado_cuenta")
                    .then((datosRespuesta) => {
                        var status = datosRespuesta.data.status;
                        if (status) {
                            Swal.close();
                            Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                            window.localStorage.clear();
                            window.location.href = '/';
                        }
                        console.log(datosRespuesta);
                        this.setState({ datosCargados: true, periodosConsultaMes: datosRespuesta.data });
                        Swal.close();
                    })
                    .catch(console.log);
                break;
            case 'rango':
                this.setState({
                    fecha_incial: '',
                    fecha_final: '',
                    consultaGeneradaRango: [],
                    loadRango: true
                });
                break
            default: break;
        }
    }

    generateExcelPQRByPeriod = (period) => {
        if (period !== null && period !== '') {
            const data = { period: period, report_type: 'period' }
            const filename = "Reporte P.Q.R - Periodo " + period + ".xlsx"
            Swal.showLoading();
            authAxios.post('excel_reports/generate-excel-pqr', data, { responseType: 'blob' })
                .then((response) => {
                    let status = response.data.status
                    if (status) {
                        Swal.close();
                        Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                        window.localStorage.clear();
                        window.location.href = '/';
                    }

                    const blob = new Blob([response.data], { type: 'application/octet-stream' })
                    // create download link for the blob
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', filename)
                    //trigger the download link
                    link.click();
                    Swal.close();
                    // Cleanup the link and object URL
                    link.parentNode.removeChild(link);
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    console.error(`There was an error while downloading: ${error}`)
                    Swal.close();
                })
        }
    }

    generateExcelPQRByRange = (start_date, end_date) => {
        if (start_date !== null && end_date !== '') {
            const report_type = 'range';
            const data = { start_date, end_date, report_type }
            const filename = "Reporte P.Q.R - Rango " + start_date + " & " + end_date + ".xlsx"
            Swal.showLoading();
            authAxios.post('excel_reports/generate-excel-pqr', data, { responseType: 'blob' })
                .then((response) => {
                    let status = response.data.status
                    if (status) {
                        Swal.close();
                        Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                        window.localStorage.clear();
                        window.location.href = '/';
                    }

                    const blob = new Blob([response.data], { type: 'application/octet-stream' })
                    // create download link for the blob
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', filename)
                    //trigger the download link
                    link.click();
                    Swal.close();
                    // Cleanup the link and object URL
                    link.parentNode.removeChild(link);
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    console.error(`There was an error while downloading: ${error}`)
                    Swal.close();
                })
        }
    }

    componentDidMount() {
        Swal.showLoading();
        authAxios.get("estado_cuentas/periodos_estado_cuenta")
            .then((datosRespuesta) => {
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, periodosConsultaMes: datosRespuesta.data });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { loadMensual, loadRango, periodo_consulta_mes, fecha_inicial,
                fecha_final, periodosConsultaMes, consultaGeneradaMes, consultaGeneradaRango } = this.state;
        return (
            <div>
                <div className="content">
                    <div className="content-wrapper">
                        <div className="content">
                            <div className="container-fluid">
                                <br />
                                <div className="card">
                                    <div className="card-header">
                                        &nbsp;
                                    </div>
                                    <div className="card-body">
                                        <h4>Consultas P.Q.R.</h4>
                                        <hr />
                                        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <button className="nav-link active" id="pills-mensual-tab" data-bs-toggle="pill" data-bs-target="#pills-mensual" type="button" role="tab" aria-controls="pills-mensual" aria-selected="true">Mensual</button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button className="nav-link" id="pills-rango-tab" data-bs-toggle="pill" data-bs-target="#pills-rango" type="button" role="tab" aria-controls="pills-rango" aria-selected="true">Rango Fechas</button>
                                            </li>
                                        </ul>
                                        <div className="tab-content" id="pills-tabContent">
                                            <div className="tab-pane fade show active" id="pills-mensual" role="tabpanel" aria-labelledby="pills-mensual-tab">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <form id='form-mensual'>
                                                            <div className="row">
                                                                <div className="col-xl-12">
                                                                    <div className='row g-3'>
                                                                        <div className="col-md-2">
                                                                            <label htmlFor="periodo_consulta_mes">Periodos Consulta</label><br />
                                                                            <input type="hidden" id='periodo_consulta_mes' name='periodo_consulta_mes' defaultValue={periodo_consulta_mes} />
                                                                            <input type="hidden" name="id_usuario" id="id_usuario" value={window.localStorage.getItem('idusuario')} />
                                                                            <div className="btn-group" role="group" aria-label="">
                                                                                <button type="button" className="btn btn-primary btn-sm" data-bs-toggle='modal' data-bs-target="#PeriodosConsultaMesModal" slot='end'>
                                                                                    <FontAwesomeIcon icon={faCalendarCheck} />
                                                                                </button>
                                                                                <input style={{ textTransform: 'uppercase' }} type="text" name="id_periodo_consulta_mes" id="id_periodo_consulta_mes" defaultValue={periodo_consulta_mes}
                                                                                    className={((this.verificarError("error_periodo_consulta_mes")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="PERIODO" aria-describedby="helpId"
                                                                                    onChange={this.cambioValor} readOnly />
                                                                            </div>
                                                                            <small id="helpId" className="invalid-feedback">Seleccione los Periodos</small>
                                                                        </div>
                                                                    </div>
                                                                    <hr />
                                                                    <div className='row'>
                                                                        <div className='col-xl-12 text-center'>
                                                                            <div className="btn-group" role="group" aria-label="">
                                                                                <button type="button" className="btn btn-secondary btn-sm" onClick={() => this.consultarInfo("mensual")}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Generar Consulta</button>&nbsp;&nbsp;
                                                                                <button type="button" className="btn btn-danger btn-sm" onClick={() => this.cancelarConsulta("mensual")}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <hr style={{ marginBottom: 0 }} />
                                                                    <div style={{ fontSize: 14 }} className="card-header text-center">
                                                                        <b>RESULTADO CONSULTA</b>
                                                                    </div>
                                                                    <div style={{ marginTop: 0 }} className='row g-3'>
                                                                        <div className='col-xl-12 text-center'>
                                                                            <div className="btn-group" role="group" aria-label="">
                                                                                <button type="button" onClick={() => this.generateExcelPQRByPeriod(periodo_consulta_mes)} className="btn btn-success btn-sm" disabled={loadMensual ? true : false}><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Generar Excel</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <hr />
                                                                    <div className='row g-3'>
                                                                        <div className='col-md-12'>
                                                                            <div className='table-responsive'>
                                                                                <table className="table table-hover table-condensed table-sm">
                                                                                    <thead className="thead-inverse">
                                                                                        <tr>
                                                                                            <th className="align-middle">RADICADO</th>
                                                                                            <th className="align-middle">TIPO ASUNTO</th>
                                                                                            <th className="align-middle">IDENTIFICACION</th>
                                                                                            <th className="align-middle">USUARIO</th>
                                                                                            <th className="align-middle">DEPARTAMENTO</th>
                                                                                            <th className="align-middle">MUNICIPIO</th>
                                                                                            <th className="align-middle">ESTADO</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {
                                                                                            consultaGeneradaMes.map((itemConsultaGeneradaMes, index) => (
                                                                                                <tr key={itemConsultaGeneradaMes.ID_PQR}>
                                                                                                    <td>{itemConsultaGeneradaMes.RADICADO}</td>
                                                                                                    <td>{itemConsultaGeneradaMes.TIPO_ASUNTO}</td>
                                                                                                    <td>{itemConsultaGeneradaMes.IDENTIFICACION}</td>
                                                                                                    <td>{itemConsultaGeneradaMes.NOMBRES} {itemConsultaGeneradaMes.APELLIDOS}</td>
                                                                                                    <td>{itemConsultaGeneradaMes.DEPARTAMENTO}</td>
                                                                                                    <td>{itemConsultaGeneradaMes.MUNICIPIO}</td>
                                                                                                    {
                                                                                                        (() => {
                                                                                                            switch (itemConsultaGeneradaMes.ESTADO_PQR) {
                                                                                                                case 1:
                                                                                                                    return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-primary">RC</span></td>)
                                                                                                                case 2:
                                                                                                                    return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">RS</span></td>)
                                                                                                                default:
                                                                                                                    return (<td></td>)
                                                                                                            }
                                                                                                        })()
                                                                                                    }
                                                                                                </tr>
                                                                                            ))
                                                                                        }
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <br />
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tab-pane fade" id="pills-rango" role="tabpanel" aria-labelledby="pills-rango-tab">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <form id='form-rango'>
                                                            <div className="row">
                                                                <div className="col-xl-12">
                                                                    <div className='row g-3'>
                                                                        <div className="col-md-2">
                                                                            <label htmlFor="fecha_inicial">Fecha Factura</label>
                                                                            <div className="input-group input-group-sm">
                                                                                <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                                                <input type="hidden" name="id_usuario" id="id_usuario" value={window.localStorage.getItem('idusuario')} />
                                                                                <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_inicial" id="fecha_inicial" value={fecha_inicial}
                                                                                    className={((this.verificarError("error_fecha_inicial")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA INICIAL" aria-describedby="helpId"
                                                                                    onChange={this.cambioValor}
                                                                                />
                                                                            </div>
                                                                            <small id="helpId" className="invalid-feedback">Seleccione la Fecha Inicial</small>
                                                                        </div>
                                                                        <div className="col-md-2">
                                                                            <label htmlFor="fecha_final">Fecha Final</label>
                                                                            <div className="input-group input-group-sm">
                                                                                <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                                                <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_final" id="fecha_final" value={fecha_final}
                                                                                    className={((this.verificarError("error_fecha_final")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA FINAL" aria-describedby="helpId"
                                                                                    onChange={this.cambioValor}
                                                                                />
                                                                            </div>
                                                                            <small id="helpId" className="invalid-feedback">Seleccione la Fecha Final</small>
                                                                        </div>
                                                                    </div>
                                                                    <hr />
                                                                    <div className='row'>
                                                                        <div className='col-xl-12 text-center'>
                                                                            <div className="btn-group" role="group" aria-label="">
                                                                                <button type="button" className="btn btn-secondary btn-sm" onClick={() => this.consultarInfo("rango")}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Generar Consulta</button>&nbsp;&nbsp;
                                                                                <button type="button" className="btn btn-danger btn-sm" onClick={() => this.cancelarConsulta("rango")}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <hr style={{ marginBottom: 0 }} />
                                                                    <div style={{ fontSize: 14 }} className="card-header text-center">
                                                                        <b>RESULTADO CONSULTA</b>
                                                                    </div>
                                                                    <div style={{ marginTop: 0 }} className='row g-3'>
                                                                        <div className='col-xl-12 text-center'>
                                                                            <div className="btn-group" role="group" aria-label="">
                                                                                <button type="button" onClick={() => this.generateExcelPQRByRange(fecha_inicial, fecha_final)} className="btn btn-success btn-sm" disabled={loadRango ? true : false}><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Generar Excel</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <hr />
                                                                    <div className='row g-3'>
                                                                        <div className='col-md-12'>
                                                                            <div className='table-responsive'>
                                                                                <table className="table table-hover table-condensed table-sm">
                                                                                    <thead className="thead-inverse">
                                                                                        <tr>
                                                                                            <th className="align-middle">RADICADO</th>
                                                                                            <th className="align-middle">TIPO ASUNTO</th>
                                                                                            <th className="align-middle">IDENTIFICACION</th>
                                                                                            <th className="align-middle">USUARIO</th>
                                                                                            <th className="align-middle">DEPARTAMENTO</th>
                                                                                            <th className="align-middle">MUNICIPIO</th>
                                                                                            <th className="align-middle">ESTADO</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {
                                                                                            consultaGeneradaRango.map((itemConsultaGeneradaRango, index) => (
                                                                                                <tr key={itemConsultaGeneradaRango.ID_PQR}>
                                                                                                    <td>{itemConsultaGeneradaRango.RADICADO}</td>
                                                                                                    <td>{itemConsultaGeneradaRango.TIPO_ASUNTO}</td>
                                                                                                    <td>{itemConsultaGeneradaRango.IDENTIFICACION}</td>
                                                                                                    <td>{itemConsultaGeneradaRango.NOMBRES} {itemConsultaGeneradaRango.APELLIDOS}</td>
                                                                                                    <td>{itemConsultaGeneradaRango.DEPARTAMENTO}</td>
                                                                                                    <td>{itemConsultaGeneradaRango.MUNICIPIO}</td>
                                                                                                    {
                                                                                                        (() => {
                                                                                                            switch (itemConsultaGeneradaRango.ESTADO_PQR) {
                                                                                                                case 1:
                                                                                                                    return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-primary">RC</span></td>)
                                                                                                                case 2:
                                                                                                                    return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">RS</span></td>)
                                                                                                                default:
                                                                                                                    return (<td></td>)
                                                                                                            }
                                                                                                        })()
                                                                                                    }
                                                                                                </tr>
                                                                                            ))
                                                                                        }
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <br />
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer text-muted">
                                        &nbsp;
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="PeriodosConsultaMesModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="PeriodosConsultaMesModalLabel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="PeriodosConsultaMesModalLabel">Periodos Consulta</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">PERIODO</th>
                                                    <th className="align-middle">MES</th>
                                                    <th className="align-middle">SELECCIONAR</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    periodosConsultaMes.map((itemPeriodosConsulta) => (
                                                        <tr key={itemPeriodosConsulta.ID_ANO}>
                                                            <td>{itemPeriodosConsulta.NOMBRE}</td>
                                                            <td>
                                                                <select name={"mes_consulta_mes_" + itemPeriodosConsulta.NOMBRE}
                                                                    id={"mes_consulta_mes_" + itemPeriodosConsulta.NOMBRE}
                                                                    className="form-select form-select-sm">
                                                                    <option value="">Seleccione el Mes</option>
                                                                    <option value="01">ENERO</option>
                                                                    <option value="02">FEBRERO</option>
                                                                    <option value="03">MARZO</option>
                                                                    <option value="04">ABRIL</option>
                                                                    <option value="05">MAYO</option>
                                                                    <option value="06">JUNIO</option>
                                                                    <option value="07">JULIO</option>
                                                                    <option value="08">AGOSTO</option>
                                                                    <option value="09">SEPTIEMBRE</option>
                                                                    <option value="10">OCTUBRE</option>
                                                                    <option value="11">NOVIEMBRE</option>
                                                                    <option value="12">DICIEMBRE</option>
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm"
                                                                        data-bs-dismiss="modal"
                                                                        onClick={() =>
                                                                            this.seleccionarPeriodo(itemPeriodosConsulta.NOMBRE, "mensual")
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Consultar;